import React from "react";
import { getSidebarParam } from "./Utils";
import Sidebar from "./UI/Sidebar";

const Layout = ({ children }) => {
  const shouldHideSidebar = getSidebarParam();

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Only show sidebar if URL parameter sidebar is not set */}
      {!shouldHideSidebar && <Sidebar />}

      {/* Main content area */}
      <div style={{ flex: 1, overflow: "auto" }}>{children}</div>
    </div>
  );
};

export default Layout;
